import { Component, Input, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { AlertType } from 'src/app/models/alert';
import { SubjectService } from 'src/app/services/subject.service';

@Component({
  selector: 'app-general-notification',
  templateUrl: './general-notification.component.html',
  styleUrls: ['./general-notification.component.css'],
})
export class GeneralNotificationComponent implements OnInit {
  MessageText: any;
  MessageIcon: any;
  notificationOpen = false;
  alert_type: string = 'alert alert-danger';
  constructor(private SS: SubjectService) {
    this.SS.generalNotification.subscribe((alert: any) => {
      if (alert) {
        if (alert.text) {
          this.MessageText = alert.text;
        }
        if (alert.icon) {
          this.MessageIcon = alert.icon;
        }
        if (alert.type) {
          let type = 0;
            type = alert.type;
            if (type == AlertType.Success)
              this.alert_type = 'alert alert-success';
            if (type == AlertType.Error) this.alert_type = 'alert alert-danger';
            if (type == AlertType.Info) this.alert_type = 'alert alert-info';
            if (type == AlertType.Warning)
              this.alert_type = 'alert alert-warning';
        }
        this.notificationOpen = true;
        // setTimeout(() => {
        //   this.notificationOpen = false;
        // }, 10000);
      }
    });
  }

  ngOnInit() {}

  closeAlert() {
    this.notificationOpen = false;
  }
}
